// export const BASE_URL = 'http://192.168.0.118:8000/v1/';
export const BASE_URL = 'https://api.housingadu.com/v1/';
